import WelcomeSvg from '../../assets/icons/svgComponents/welcome'
import Button from '../button'
import * as S from './styles'

type Props = {
  buttonInnerText: string
  handleClick: () => void
  title: any
}

const FirstStepsModal = ({ buttonInnerText, handleClick, title }: Props) => {
  return (
    <S.Wrapper>
      <div className="circle">
        <WelcomeSvg />
      </div>
      <S.Title>Bem vindo(a) ao Wexer Psi!</S.Title>
      <p>{title}</p>
      <Button onClick={handleClick}>{buttonInnerText}</Button>
    </S.Wrapper>
  )
}

export default FirstStepsModal
